export interface CopyRegisterLendAndReturnConditionRequest {
  fromBranchCode: string
  fromLendType: string
  fromUserType: string
  toBranchCode: string
  toLendType: string
  toUserTypeList: string[]
  _force: boolean
}

export function CopyRegisterLendAndReturnConditionRequestToJSON(
  value: CopyRegisterLendAndReturnConditionRequest
): any {
  return {
    from_branch_code:
      value.fromBranchCode !== '' ? value.fromBranchCode : undefined,
    from_lend_type: value.fromLendType !== '' ? value.fromLendType : undefined,
    from_user_type: value.fromUserType !== '' ? value.fromUserType : undefined,
    to_branch_code: value.toBranchCode !== '' ? value.toBranchCode : undefined,
    to_lend_type: value.toLendType !== '' ? value.toLendType : undefined,
    to_user_type_list:
      value.toUserTypeList.length > 0 ? value.toUserTypeList : undefined,
    _force: value._force ?? undefined
  }
}
